import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../../../../firebase';
import LinksNotification from '../../../../components/appComponents/linksNotification';
import YTVideoProcessor from './YTVideoProcessor';
import YTVideoDisplay from './YTVideoDisplay';
import './linkWorkspace.css';

const LinkWorkspace = ({
  onInputChange,
  content_id,
  isTranscriptAvailable,
  isYTProcessing,
  isTranscriptError,
  onBeforeUpload,
  onAfterUpload,
}) => {
  const [workspaceVideoDetails, setWorkspaceVideoDetails] = useState({});
  const [doneVideos, setDoneVideos] = useState([]);

  useEffect(() => {
    const user = auth.currentUser;
    if (user && content_id) {
      const workspaceDocRef = doc(
        db,
        'users',
        user.uid,
        'workspaceContent',
        `workspace-${content_id}`
      );
      const unsubscribe = onSnapshot(workspaceDocRef, (docSnap) => {
        if (!docSnap.exists()) return;
        const {
          yt_video_id,
          yt_video_title,
          video_thumbnail,
          video_duration_in_seconds
        } = docSnap.data();
        const localKey = `workspacelink_${user.uid}_${content_id}`;

        if (isTranscriptAvailable) {
          const stored = localStorage.getItem(localKey);
          if (stored) {
            const parsed = JSON.parse(stored);
            if (workspaceVideoDetails.videoId !== parsed.videoId) {
              setWorkspaceVideoDetails(parsed);
              setDoneVideos(d => (d.includes(parsed.videoId) ? d : [...d, parsed.videoId]));
              onInputChange(true);
            }
          } else if (
            yt_video_id &&
            yt_video_title &&
            video_thumbnail &&
            video_duration_in_seconds
          ) {
            const details = {
              thumbnailUrl:    video_thumbnail,
              durationSeconds: video_duration_in_seconds,
              captionAvailable: true,
              videoId:          yt_video_id,
              title:            yt_video_title
            };
            setWorkspaceVideoDetails(details);
            localStorage.setItem(localKey, JSON.stringify(details));
            setDoneVideos(d => (d.includes(yt_video_id) ? d : [...d, yt_video_id]));
            onInputChange(true);
          }
        } else if (
          yt_video_id &&
          yt_video_title &&
          video_thumbnail &&
          video_duration_in_seconds
        ) {
          const details = {
            thumbnailUrl:    video_thumbnail,
            durationSeconds: video_duration_in_seconds,
            captionAvailable: false,
            videoId:          yt_video_id,
            title:            yt_video_title
          };
          setWorkspaceVideoDetails(details);
          setDoneVideos(d => (d.includes(yt_video_id) ? d : [...d, yt_video_id]));
          onInputChange(true);
        }
      });
      return unsubscribe;
    }
  }, [content_id, isTranscriptAvailable, onInputChange, workspaceVideoDetails.videoId]);

  return (
    <div className="worklink-uploaddashboard">
      <div className="worklink-dashboard-container">
        <LinksNotification />

        {!isTranscriptAvailable ? (
          <YTVideoProcessor
            workspaceVideoDetails={workspaceVideoDetails}
            setWorkspaceVideoDetails={setWorkspaceVideoDetails}
            setDoneVideos={setDoneVideos}
            doneVideos={doneVideos}
            onInputChange={onInputChange}
            content_id={content_id}
            isTranscriptAvailable={isTranscriptAvailable}
            isYTProcessing={isYTProcessing}
            isTranscriptError={isTranscriptError}
            onBeforeUpload={onBeforeUpload}
            onAfterUpload={onAfterUpload}
          />
        ) : (
          <YTVideoDisplay
            workspaceVideoDetails={workspaceVideoDetails}
            doneVideos={doneVideos}
          />
        )}
      </div>
    </div>
  );
};

export default LinkWorkspace;
